import React from 'react';
import { Select, Space } from 'antd';
import type { Node } from '@xyflow/react';
import styles from '../../../event-timeline.module.css';

const { Option } = Select;

interface EventCompletedParamsProps {
  params: any;
  setParams: (params: any) => void;
  allEvents: Node[];
}

const EventCompletedParams: React.FC<EventCompletedParamsProps> = ({
  params,
  setParams,
  allEvents,
}) => {
  return (
    <div>
      <Space direction='vertical' style={{ width: '100%' }}>
        <span className={styles.label}>Event:</span>
        <Select
          value={params.eventId}
          onChange={(value) => setParams({ ...params, eventId: value })}
          style={{ width: '100%' }}
          placeholder='Select an event'
        >
          {allEvents.map((event) => (
            <Option key={event.id} value={event.id}>
              {event.data.name as string} (ID: {event.id})
            </Option>
          ))}
        </Select>
      </Space>
    </div>
  );
};

export default EventCompletedParams;
